import { connect, MapStateToProps } from 'react-redux';
import { Props } from './SimpleThread';
import { getThreadState } from '../../selectors';

export type StateProps = Pick<Props, 'streamId' | 'itemCount' | 'isFetching'>;
export type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (
  state,
  { commentableTypeId, commentableItemId, parentId }
) => {
  const threadState = getThreadState(
    state,
    commentableTypeId,
    commentableItemId,
    parentId
  );
  return {
    ...threadState,
    itemCount: threadState.items.length,
  };
};

export default connect(mapStateToProps);
